module.exports = __webpack_public_path__ + "img/creationProduction1.ea5fb621.png";